import { isArray, isObject } from "lodash";

export class ListUtility {

    /**
     * 
     * @param lst List of strings that need to be 
     * @param conjunction 
     * @param ifEmpty 
     * @returns 
     */
    static toOxford(lst: string[], conjunction: string, ifEmpty: string) {
        // https://stackoverflow.com/questions/15069587/is-there-a-way-to-join-the-elements-in-an-js-array-but-let-the-last-separator-b

        const l = lst.length;
        if (!l) return ifEmpty;
        if (l < 2) return lst[0];
        if (l < 3) return lst.join(` ${conjunction} `);
        return lst.join(', ').replace(/, ([^,]*)$/, ` ${conjunction} $1`);
    }

    /**
     * Creates a Array of key-value of an array
     * @param enumme Any enum
     * @returns an array of key-value
     */
    static enumToArray(enumme: any): { key: number, value: string }[] {
        /** https://stackoverflow.com/a/43101184 */
        let map: { key: number; value: string }[] = [];

        for (var n in enumme) {
            if (typeof enumme[n] === 'number') {
                map.push({ key: <any>enumme[n], value: n });
            }
        }

        return map;
    }

    static reduceEnumToListValue(enumme: any) {
        const StringIsNumber = (val: any) => isNaN(Number(val)) === false;

        return Object.keys(enumme)
            .filter(StringIsNumber)
            .map(key => enumme[key]);
    }
}

interface SyncableArray {
    __modelSyncSetName: string,
    items: Array<any>
}

export class ObjectMetadataManager {

    /**
     * This function post-processes deserialized API responses.
     * + convert all 'null' to 'undefined'
     * + flatten all model sync set to their constituent items. Viz:
     * 
     *   Before: `foo: { __modelSyncSetName: string, items: Array<T> }`  
     *   After:  `foo: Array<T>`
     */
    static processApiResponseData<T>(obj: any): T {

        function process(target: any) {
            if (target === null) {
                return undefined;
            }

            if (!isObject(target))
                return target;

            const syncArray: SyncableArray = target as SyncableArray;

            if (syncArray.__modelSyncSetName && isArray(syncArray.items)) {
                target = syncArray.items;
            }

            for (const key in target) {
                if (!Object.prototype.hasOwnProperty.call(target, key)) {
                    continue;
                }

                target[key] = process(target[key]);
            }

            return target;
        }

        let returnObj: T = process(obj);
        return returnObj;
    }
}
